import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { useAppDispatch } from "../Core/store.hooks";
//import { Settings } from "../Common/Types/types";

const getInitialHomepage = () => {
  const savedSettings = JSON.parse(localStorage.getItem("settings"));
    
    let homepage: string = "events";
    if (savedSettings != null && savedSettings != undefined) {
        if (savedSettings.homepage != undefined) {
            homepage = savedSettings.homepage;
            
        }
    }

    return homepage;
    
};

const initialState: any = {
  homepage: getInitialHomepage(),
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<any>) => {
      return action.payload;
      },
      updateSelectedHomepage: (state, action: PayloadAction<any>) => {
          return {
              ...state,
              homepage: action.payload
          };
      },
  },
});

export const { updateSelectedHomepage } = settingsSlice.actions;

export const getSettingsSelector = (state: RootState) => state.settings;

export default settingsSlice.reducer;
